import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sayout-loud',
})

export default class SayoutLoud extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private isPause: boolean = false;

    /*
     * Hold the audio details
     */
    private audioRecorder: any = null;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    private get answerObject() {
        return this.content.answerObject;
    }

    private get answers() {
      return this.showCorrect ? this.baseQuestions : this.answerObject;
    }

    private answerIndex: number = 0;

    // ---------------------------------------------------------------
    // Hooks

    private created() {
      for (let index = 0; index < this.answers.length; index++) {
        const element = this.answers[index];
        if (element.correctAnswer) {
          element.correctAnswer.map((data: any) => {
            this.hightLightDefaultWord(data, index);
            return data;
          });
        }
      }
    }


    // -----------------------------------------------------------------
    // Actions

    private onPlayAudio(container: any, url: any, index: number) {
      const component = this;
      let audio = component.audioRecorder;
      if (!audio || component.answerIndex !== index) {
        audio = new Audio(url);
        component.answerIndex = index ;
      }
      component.audioRecorder = audio;
      audio.play();
      component.isPause = true;
      audio.ontimeupdate = () => {
        // component
        //   .querySelector(
        //     `.answer-container .${container} .audio-progress .progress-filling`
        //   )
        //   .css('width', `${(_audio.currentTime / _audio.duration) * 100}%`);
      };
      audio.addEventListener('ended', () => {
        component.isPause = false ;
      });
    }


    // --------------------------------------------------------------
    // Methods


    private hightLightDefaultWord(text: any, answerIndex: number) {
      const component = this;
      let innerHTML = '';
      const start = text.split(':')[1];
      const end = text.split(':')[2];
      const fulltext = text.split(':')[0];
      const html = `<span class="correct">${fulltext}</span>`;
      // String.prototype.replaceBetween = (start: number, end: number, what:string) => {
      //   return this.substring(0, start) + what + this.substring(end);
      // };
      if (component.$el.querySelectorAll(`.answer-sayout .answer-edit-${answerIndex}`)[0]) {
        component
            .$el.querySelectorAll(`.answer-sayout .answer-edit-${answerIndex}`)[0]
          .childNodes.forEach((childNode: any) => {
            if (
              childNode.data &&
              childNode.data.substring(start, end) === fulltext
            ) {
              innerHTML =
                innerHTML +
                childNode.data.replaceBetween(start, end, html.trim());
            } else if (childNode.data) {
              innerHTML = innerHTML + childNode.data;
            } else {
              innerHTML = innerHTML + childNode.outerHTML;
            }
          });
        (component
          .$el.querySelector(`.answer-sayout .answer-edit-${answerIndex}`) as HTMLElement).innerHTML = innerHTML;
      }
    }




}
